export default __webpack_public_path__ + "static/media/Nang.d2a00547.png";